const KNOWN_MESSAGES: [string, string][] = [
  ["Invalid login credentials", "Credenciales inválidas. Verifica tu correo y contraseña."],
  ["Email not confirmed", "Tu correo no ha sido confirmado. Revisa tu bandeja de entrada."],
  ["already registered", "Este correo ya está registrado."],
  ["Password should be at least 6 characters", "La contraseña debe tener al menos 6 caracteres."],
  ["New password should be different from the old password", "La nueva contraseña debe ser diferente a la anterior."],
  ["Password is too weak", "La contraseña es muy débil o común. Por favor, elige una más fuerte."],
  ["weak_password", "La contraseña es muy débil o común. Por favor, elige una más compleja."],
  ["signup_weak_password", "La contraseña es muy débil. Elige una contraseña más segura."],
  ["Auth session missing", "Tu sesión ha expirado. Inicia sesión de nuevo."],
  ["JWT expired", "Tu sesión ha expirado. Inicia sesión de nuevo."],
  ["Email rate limit exceeded", "Demasiados intentos. Espera unos minutos."],
  ["security purposes, you can only request this after", "Espera unos segundos antes de intentar de nuevo."],
];

const FALLBACK = "Ocurrió un error. Intenta de nuevo.";

export function safeError(error: unknown, fallback?: string): string {
  const msg =
    typeof error === "string"
      ? error
      : (error as any)?.message;

  if (!msg || typeof msg !== "string") {
    console.error("[supabase]", error);
    return fallback ?? FALLBACK;
  }

  for (const [pattern, translated] of KNOWN_MESSAGES) {
    if (msg.includes(pattern)) {
      console.error("[supabase]", msg);
      return translated;
    }
  }

  console.error("[supabase]", msg);
  return fallback ?? FALLBACK;
}
